import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const KeywordGapListPage = lazyWithRetry(() => import('./pages/KeywordGapListPage'))
const KeywordGapNewPage = lazyWithRetry(() => import('./pages/KeywordGapNewPage'))
const KeywordGapDetailPage = lazyWithRetry(() => import('./pages/KeywordGapDetailPage'))

const routes: AppRoute[] = [
  {
    path: 'keyword-gaps',
    meta: {
      title: 'keywordGap.title',
      require: { minRole: ROLE.MEMBER },
    },
    children: [
      {
        index: true,
        element: KeywordGapListPage,
      },
      {
        path: 'new',
        element: KeywordGapNewPage,
      },
      {
        path: ':id',
        element: KeywordGapDetailPage,
      },
    ],
  },
]

export default routes
